import React, { useState } from 'react';
import { Typography, IconButton, Box, Divider } from '@mui/material';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import TreeDataView from '../../../tree-data-view';
import { headCells } from '../parsed-data/head-cells';

const nA = 'N/A';

export const convertJsonToTreeTableFormat = (input: any, iteratedTitle?: string | null) =>
  Object.keys(input).map((key, iterator: number) => {
    if (input[key] && Object.keys(input[key]).length > 0 && typeof input[key] === 'object') {
      const objectItems: any = Object.keys(input[key]).map((objectKey: any) => {
        const passTitle = Array.isArray(input[key][objectKey]) ? objectKey : null;
        if (typeof input[key][objectKey] !== 'object') {
          if (input[key]?.messageQuality === 'MESSAGE_QUALITY_STABLE_DATA') {
            // systemComponentsList
            if (input[key]?.systemComponentsList && input[key]?.systemComponentsList.length > 0) {
              input[key].systemComponentsList.forEach((systemComponent: any) => {
                const index1939NameHexStringValue = systemComponent?.j1939NameHexStr;
                const deviceIdHexString = systemComponent?.j1939DeviceIdHexStr;
                const sha256HexString = systemComponent?.sha256HexStr;
                const ipv4AddressHexString = systemComponent?.ipv4AddressHexStr;
                const cdlDeviceIdHexString = systemComponent?.cdlDeviceIdHexStr;
                const ethernetDeviceIdHexString = systemComponent?.ethernetDeviceIdHexStr;
                /* eslint no-param-reassign: "error" */
                if (index1939NameHexStringValue !== undefined) systemComponent.j1939Name = index1939NameHexStringValue;
                if (deviceIdHexString !== undefined) systemComponent.j1939DeviceId = deviceIdHexString;
                if (sha256HexString !== undefined) systemComponent.sha256 = sha256HexString;
                if (ipv4AddressHexString !== undefined) systemComponent.ipv4Address = ipv4AddressHexString;
                if (cdlDeviceIdHexString !== undefined) systemComponent.cdlDeviceId = cdlDeviceIdHexString;
                if (ethernetDeviceIdHexString !== undefined) systemComponent.ethernetDeviceId = ethernetDeviceIdHexString;
              });
            }
            // radiosList
            if (input[key]?.radiosList && input[key]?.radiosList.length > 0) {
              input[key].radiosList.forEach((list: any) => {
                const macAddressValue = list?.hardwareInformation?.macAddressHexStr;
                if (macAddressValue !== undefined) list.hardwareInformation.macAddress = macAddressValue;
                delete list.hardwareInformation.macAddressHexStr;
              });
            }
            // configurationsList
            if (input[key]?.configurationsList && input[key]?.configurationsList.length > 0) {
              input[key]?.configurationsList.forEach((config: any) => {
                const sha1HexString = config?.sha1HexStr;
                if (sha1HexString !== undefined) config.sha1 = sha1HexString;
                delete config.sha1HexStr;
              });
            }
          }
          const objectKeys = ['j1939DeviceIdHexStr', 'j1939NameHexStr', 'sha256HexStr', 'ipv4AddressHexStr', 'cdlDeviceIdHexStr', 'ethernetDeviceIdHexStr','reportingEcuidHex'];
          if (objectKeys.includes(objectKey)) {
            return ""
          }
          let hexReportingEcuid;
          const hexKeys = new Set(["reportingEcuid"]);
          if (hexKeys.has(objectKey)) {
            const decimalValue = input[key][objectKey];
            const hexValue = decimalValue.toString(16).toUpperCase();
            const targetLength = decimalValue <= 0xFFFF ? 4 : 8;
            hexReportingEcuid = hexValue.padStart(targetLength, '0');
          }
          return {
            fieldName: objectKey,
            hexValue: hexKeys.has(objectKey) ? hexReportingEcuid : nA,
            convertedValue: nA,
            displayValue:
              typeof input[key][objectKey] === 'boolean'
                ? `${input[key][objectKey]}`
                : hexKeys.has(objectKey) ? input[key][objectKey] : input[key][objectKey],
          };
        }
        return {
          fieldName: objectKey,
          subRows: convertJsonToTreeTableFormat(input[key][objectKey], passTitle),
        };
      });
      return {
        fieldName: iteratedTitle ? `${iteratedTitle}-${iterator + 1}` : key,
        subRows: objectItems,
      };
    }
    return {
      fieldName: key,
      hexValue: nA,
      convertedValue: nA,
      displayValue: typeof input[key] === 'boolean' ? `${input[key]}` : input[key],
    };
  });

const ParsedJsonData = ({
  parsedJSON,
  updateHeight,
}: {
  parsedJSON: any;
  updateHeight: Function;
}) => {
  const data = { ...parsedJSON };
  delete data.header;
  const parsedJson = convertJsonToTreeTableFormat(data);


  const [expanded, setExpanded] = useState(true);
  const toggleExpanded = () => {
    updateHeight();
    setExpanded(!expanded);
  };

  return (
    <Box pb={1}>
      <Divider />
      <Box display="flex" alignItems="center" pt={1}>
        <Typography variant="h6">Parsed Data</Typography>
        <IconButton
          onClick={toggleExpanded}
          aria-label="expand"
          style={{ width: '1rem', height: '1rem' }}
          size="large"
        >
          {expanded ? <ExpandMore /> : <ChevronRight />}
        </IconButton>
      </Box>
      {expanded && (
        <Box py={1.5}>
          <TreeDataView
            data={parsedJson}
            headCells={headCells}
            maxHeight={300}
            updateHeight={updateHeight}
          />
        </Box>
      )}
    </Box>
  );
};

export default ParsedJsonData;
